export const SET_ACTION_TAKEN_LABELS = 'SET_ACTION_TAKEN_LABELS';
